import { useQuery } from "@tanstack/react-query";

import {
	adminRequestKeys,
	getAdminRequest,
} from "@/features/applications/api/admin-requests";

export function useRequestDetail(id: string | undefined) {
	return useQuery({
		queryKey: adminRequestKeys.detail(id ?? ""),
		queryFn: () => getAdminRequest(id as string),
		enabled: Boolean(id),
	});
}
